import React, { useRef } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { InputAdornment } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

function MuiInputField({
  placeHolder,
  border,
  maxLength,
  input,
  prefix,
  multiline = false,
  rows = 4,
  ...props
}) {
  const inputProps = {
    style: {
      height: multiline ? "auto" : "43px",
      padding: multiline ? "10px" : "0px 0px",
      backgroundColor: "white",
      // border: border ? border : `2px solid #e9eff7`,
      border: border ? border : multiline ? "0px" : `2px solid #e9eff7`,
      paddingLeft: multiline ? "10px" : "10px",
      color: "#232425",
      resize: multiline ? "vertical" : "none",
    },
    maxLength: maxLength,
    ...input,
  };

  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);

  const handleKeyDown = (event, inputRef) => {
    if (event.key === "Enter" && !multiline) {
      event.preventDefault();
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }
  };

  return (
    <Box
      component="form"
      sx={{
        "& > :not(style)": {
          width: "100%",
          height: multiline ? "auto" : "40px",
        },
      }}
      noValidate
    >
      <TextField
        {...props}
        autoComplete="off"
        id="outlined-basic"
        variant="outlined"
        placeholder={placeHolder}
        multiline={multiline}
        rows={multiline ? rows : undefined}
        InputProps={
          prefix
            ? {
                startAdornment: (
                  <InputAdornment position="start">
                    {prefix || <AddIcon />}
                  </InputAdornment>
                ),
              }
            : undefined
        }
        inputProps={inputProps}
        inputRef={inputRef1}
        onKeyDown={(event) => handleKeyDown(event, inputRef2)}
      />
    </Box>
  );
}

export default MuiInputField;
